











































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getCompanyInfo } from "@/utils/getCompanyInfo";

@Component
export default class PhoneCopySuggestion extends Vue {
	@Prop({ type: String, default: "" }) readonly value!: string;
	@Prop({ type: String, required: true }) readonly formId!: string;
	@Prop({ type: Array, required: true }) readonly suggestions!: string[];
	@Prop({ type: Number, required: true }) readonly maxLength!: number;
	@Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;
	@Prop({ type: Boolean, default: false }) readonly allowEmpty!: boolean;
	@Prop({ type: Boolean, default: false }) readonly reportView!: boolean;
	@Prop({ type: String, default: "form.phoneTitleSuggestion.description" })
	readonly descriptionKey!: string;

	observer: IntersectionObserver | null = null;

	mounted() {
		if (!this.reportView) return;
		// 整组建议仅由主标题卡片上报一次曝光，避免四个字段重复计数。
		this.observer = new IntersectionObserver((entries) => {
			if (this.observer && entries.some((entry) => entry.isIntersecting)) {
				this.report("form_edit_phoneoptimizer", "view");
				this.observer.disconnect();
				this.observer = null;
			}
		});
		this.observer.observe(this.$el);
	}

	beforeDestroy() {
		this.observer?.disconnect();
	}

	report(event: string, eventType: "view" | "click") {
		const account: Record<string, unknown> = JSON.parse(
			localStorage.getItem("displayInfo") || "{}",
		);
		// 直接沿用公共采集字段，不在 DOM 留下推荐属性，避免普通手动操作误带来源。
		window?.gtagNew?.("event", event, {
			event_name: event,
			event_type: eventType,
			Company_id: getCompanyInfo().id,
			login_id: account.id,
			login_type: account.innerUserType,
			path_url: window.location.href,
			time: new Date(),
			popId: this.formId,
			recommendationType: "optimize_phone_copy",
		});
	}

	expanded = true;
	suggestionIndex = 0;
	candidates: string[] = [];

	@Watch("suggestions", { immediate: true, deep: true })
	resetSuggestions() {
		this.candidates = [...this.suggestions];
		this.suggestionIndex = 0;
	}

	get candidate() {
		return this.candidates[this.suggestionIndex] || "";
	}

	set candidate(value: string) {
		Vue.set(this.candidates, this.suggestionIndex, value);
	}

	get applied() {
		return (this.value || "") === this.candidate;
	}

	get valid() {
		return (
			this.candidate.length <= this.maxLength &&
			(this.allowEmpty || !!this.candidate.trim())
		);
	}

	nextSuggestion() {
		if (this.readOnly || this.suggestions.length < 2) return;
		// 三组建议循环切换，保留各组临时编辑；切换本身不修改弹窗字段。
		this.suggestionIndex = (this.suggestionIndex + 1) % this.suggestions.length;
		this.report("form_edit_phoneoptimizer_change", "click");
	}

	apply() {
		if (this.readOnly || this.applied || !this.valid) return;
		// 仅显式应用当前建议时替换当前字段，状态始终与弹窗当前文案比较。
		this.$emit("input", this.candidate);
		this.$emit("change");
		this.report("form_edit_phoneoptimizer_click", "click");
	}
}
